/* eslint-disable react/prop-types */
import React from 'react';

import HpHouseOutlined from '../../../images/hotpads-house-outlined.inline.svg';
import Link from '@zg-rentals/multibrand-ui/lib/Link';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Col from '@zg-rentals/multibrand-ui/lib/Col';
import Section from '@zg-rentals/multibrand-ui/lib/Section';
import Center from '@zg-rentals/multibrand-ui/lib/Center';

import sharedConfig from '../../../sharedConfig';

import './style.scss';

const InquiryNotFound = (props) => {
  const { brand } = props;

  return (
    <div className="InquiryNotFound">
      <Center>
        <HpHouseOutlined className="InquiryNotFound-house" fill="#DBDBDB" />
        <Section>
          <Text type="body">The listing was not found.</Text>
          <Row>
            <Col>
              <Text type="body">
                Still looking?{' '}
                <Link href={sharedConfig.brandUrls[brand]} target="_blank">
                  Search for homes.
                </Link>
                .
              </Text>
            </Col>
          </Row>
        </Section>
      </Center>
    </div>
  );
};

export default InquiryNotFound;
